import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  LIST_COMPANY_VEHICLES,
  CREATE_COMPANY_VEHICLE,
  UPDATE_COMPANY_VEHICLE,
  DELETE_COMPANY_VEHICLE,
  GET_COMPANY_VEHICLE_DETAILS,
  COMPANY_VEHICLE_SEARCH,
  COMPANY_VEHICLE_STATUS_LIST,
  COMPANY_VEHICLE_STATUS_CREATE,
  COMPANY_VEHICLE_STATUS_UPDATE,
  COMPANY_VEHICLE_STATUS_DELETE,
  COMPANY_VEHICLE_TYPE_LIST,
  COMPANY_VEHICLE_TYPE_CREATE,
  COMPANY_VEHICLE_TYPE_UPDATE,
  COMPANY_VEHICLE_TYPE_DELETE,
  COMPANY_VEHICLE_CHECK_TYPE_LIST,
  COMPANY_VEHICLE_CHECK_TYPE_CREATE,
  COMPANY_VEHICLE_CHECK_TYPE_UPDATE,
  COMPANY_VEHICLE_CHECK_TYPE_DELETE,
  COMPANY_VEHICLE_CHECK_LIST,
  COMPANY_VEHICLE_CHECK_CREATE,
  COMPANY_VEHICLE_CHECK_UPDATE,
  COMPANY_VEHICLE_CHECK_DELETE,
  COMPANY_VEHICLE_TO_STAFF_LIST,
  COMPANY_VEHICLE_TO_STAFF_CREATE,
  COMPANY_VEHICLE_TO_STAFF_UPDATE,
  COMPANY_VEHICLE_TO_STAFF_DELETE,
  COMPANY_VEHICLE_TO_STAFF_SEARCH,
  COMPANY_VEHICLE_CHECKOUT,
  COMPANY_VEHICLE_CHECKIN,
  COMPANY_VEHICLE_NOTE_LIST,
  COMPANY_VEHICLE_NOTE_CREATE,
  COMPANY_VEHICLE_NOTE_UPDATE,
  COMPANY_VEHICLE_NOTE_DELETE,
  COMPANY_VEHICLE_RECENT_ACTIVITY_LIST,
  COMPANY_VEHICLE_GPS_TRACKER_LIST,
  COMPANY_VEHICLE_GPS_TRACKER_CREATE,
  COMPANY_VEHICLE_GPS_TRACKER_UPDATE,
  COMPANY_VEHICLE_GPS_TRACKER_DELETE,
  COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES,
  COMPANY_VEHICLE_GPS_TRACKER_REFRESH,
  COMPANY_VEHICLE_ATTACHMENT_SEARCH,
  COMPANY_VEHICLE_ATTACHMENT_DELETE,
} from "./actionType";

import {
  listCompanyVehiclesSuccess,
  listCompanyVehiclesFailure,
  createCompanyVehicleSuccess,
  createCompanyVehicleFailure,
  updateCompanyVehicleSuccess,
  updateCompanyVehicleFailure,
  deleteCompanyVehicleSuccess,
  deleteCompanyVehicleFailure,
  getCompanyVehicleDetailsSuccess,
  getCompanyVehicleDetailsFailure,
  searchCompanyVehicleSuccess,
  searchCompanyVehicleFailure,
  listCompanyVehicleStatusSuccess,
  listCompanyVehicleStatusFailure,
  createCompanyVehicleStatusSuccess,
  createCompanyVehicleStatusFailure,
  updateCompanyVehicleStatusSuccess,
  updateCompanyVehicleStatusFailure,
  deleteCompanyVehicleStatusSuccess,
  deleteCompanyVehicleStatusFailure,
  listCompanyVehicleTypeSuccess,
  listCompanyVehicleTypeFailure,
  createCompanyVehicleTypeSuccess,
  createCompanyVehicleTypeFailure,
  updateCompanyVehicleTypeSuccess,
  updateCompanyVehicleTypeFailure,
  deleteCompanyVehicleTypeSuccess,
  deleteCompanyVehicleTypeFailure,
  listCompanyVehicleCheckTypeSuccess,
  listCompanyVehicleCheckTypeFailure,
  createCompanyVehicleCheckTypeSuccess,
  createCompanyVehicleCheckTypeFailure,
  updateCompanyVehicleCheckTypeSuccess,
  updateCompanyVehicleCheckTypeFailure,
  deleteCompanyVehicleCheckTypeSuccess,
  deleteCompanyVehicleCheckTypeFailure,
  listCompanyVehicleCheckSuccess,
  listCompanyVehicleCheckFailure,
  createCompanyVehicleCheckSuccess,
  createCompanyVehicleCheckFailure,
  updateCompanyVehicleCheckSuccess,
  updateCompanyVehicleCheckFailure,
  deleteCompanyVehicleCheckSuccess,
  deleteCompanyVehicleCheckFailure,
  listCompanyVehicleToStaffSuccess,
  listCompanyVehicleToStaffFailure,
  createCompanyVehicleToStaffSuccess,
  createCompanyVehicleToStaffFailure,
  updateCompanyVehicleToStaffSuccess,
  updateCompanyVehicleToStaffFailure,
  deleteCompanyVehicleToStaffSuccess,
  deleteCompanyVehicleToStaffFailure,
  searchCompanyVehicleToStaffSuccess,
  searchCompanyVehicleToStaffFailure,
  checkoutCompanyVehicleSuccess,
  checkoutCompanyVehicleFailure,
  checkinCompanyVehicleSuccess,
  checkinCompanyVehicleFailure,
  listCompanyVehicleNoteSuccess,
  listCompanyVehicleNoteFailure,
  createCompanyVehicleNoteSuccess,
  createCompanyVehicleNoteFailure,
  updateCompanyVehicleNoteSuccess,
  updateCompanyVehicleNoteFailure,
  deleteCompanyVehicleNoteSuccess,
  deleteCompanyVehicleNoteFailure,
  listCompanyVehicleRecentActivitySuccess,
  listCompanyVehicleRecentActivityFailure,
  listCompanyVehicleGpsTrackerSuccess,
  listCompanyVehicleGpsTrackerFailure,
  createCompanyVehicleGpsTrackerSuccess,
  createCompanyVehicleGpsTrackerFailure,
  updateCompanyVehicleGpsTrackerSuccess,
  updateCompanyVehicleGpsTrackerFailure,
  deleteCompanyVehicleGpsTrackerSuccess,
  deleteCompanyVehicleGpsTrackerFailure,
  listGpsLiveDevicesSuccess,
  listGpsLiveDevicesFailure,
  refreshCompanyVehicleGpsTrackerSuccess,
  refreshCompanyVehicleGpsTrackerFailure,
  searchCompanyVehicleAttachmentSuccess,
  searchCompanyVehicleAttachmentFailure,
  deleteCompanyVehicleAttachmentSuccess,
  deleteCompanyVehicleAttachmentFailure,
} from "./action";

import {
  listCompanyVehiclesApi,
  createCompanyVehicleApi,
  updateCompanyVehicleApi,
  deleteCompanyVehicleApi,
  getCompanyVehicleDetailsApi,
  searchCompanyVehicleApi,
  listCompanyVehicleStatusApi,
  createCompanyVehicleStatusApi,
  updateCompanyVehicleStatusApi,
  deleteCompanyVehicleStatusApi,
  listCompanyVehicleTypeApi,
  createCompanyVehicleTypeApi,
  updateCompanyVehicleTypeApi,
  deleteCompanyVehicleTypeApi,
  listCompanyVehicleCheckTypeApi,
  createCompanyVehicleCheckTypeApi,
  updateCompanyVehicleCheckTypeApi,
  deleteCompanyVehicleCheckTypeApi,
  listCompanyVehicleCheckApi,
  createCompanyVehicleCheckApi,
  updateCompanyVehicleCheckApi,
  deleteCompanyVehicleCheckApi,
  listCompanyVehicleToStaffApi,
  createCompanyVehicleToStaffApi,
  updateCompanyVehicleToStaffApi,
  deleteCompanyVehicleToStaffApi,
  searchCompanyVehicleToStaffApi,
  checkoutCompanyVehicleApi,
  checkinCompanyVehicleApi,
  listCompanyVehicleNoteApi,
  createCompanyVehicleNoteApi,
  updateCompanyVehicleNoteApi,
  deleteCompanyVehicleNoteApi,
  listCompanyVehicleRecentActivityApi,
  listCompanyVehicleGpsTrackerApi,
  createCompanyVehicleGpsTrackerApi,
  updateCompanyVehicleGpsTrackerApi,
  deleteCompanyVehicleGpsTrackerApi,
  listGpsLiveDevicesApi,
  refreshCompanyVehicleGpsTrackerApi,
  searchCompanyVehicleAttachmentApiCall,
  deleteCompanyVehicleAttachmentApiCall,
} from "../../helpers/fakebackend_helper";

// List Company Vehicles
function* listCompanyVehicles() {
  try {
    const response = yield call(listCompanyVehiclesApi);
    yield put(listCompanyVehiclesSuccess(response));
  } catch (error) {
    yield put(listCompanyVehiclesFailure(error));
  }
}

function* listCompanyVehiclesWatcher() {
  yield takeEvery(LIST_COMPANY_VEHICLES, listCompanyVehicles);
}

// Create Company Vehicle
function* createCompanyVehicle({ payload }) {
  try {
    const response = yield call(createCompanyVehicleApi, payload);
    yield put(createCompanyVehicleSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleFailure(error));
  }
}

function* createCompanyVehicleWatcher() {
  yield takeEvery(CREATE_COMPANY_VEHICLE, createCompanyVehicle);
}

// Update Company Vehicle
function* updateCompanyVehicle({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleApi, payload);
    yield put(updateCompanyVehicleSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleFailure(error));
  }
}

function* updateCompanyVehicleWatcher() {
  yield takeEvery(UPDATE_COMPANY_VEHICLE, updateCompanyVehicle);
}

// Delete Company Vehicle
function* deleteCompanyVehicle({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleApi, payload);
    yield put(deleteCompanyVehicleSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleFailure(error));
  }
}

function* deleteCompanyVehicleWatcher() {
  yield takeEvery(DELETE_COMPANY_VEHICLE, deleteCompanyVehicle);
}

// Get Company Vehicle Details
function* getCompanyVehicleDetails({ payload }) {
  try {
    const response = yield call(getCompanyVehicleDetailsApi, payload);
    yield put(getCompanyVehicleDetailsSuccess(response));
  } catch (error) {
    yield put(getCompanyVehicleDetailsFailure(error));
  }
}

function* getCompanyVehicleDetailsWatcher() {
  yield takeEvery(GET_COMPANY_VEHICLE_DETAILS, getCompanyVehicleDetails);
}

// Search Company Vehicle
function* searchCompanyVehicle({ payload }) {
  try {
    const response = yield call(searchCompanyVehicleApi, payload);
    yield put(searchCompanyVehicleSuccess(response));
  } catch (error) {
    yield put(searchCompanyVehicleFailure(error));
  }
}

function* searchCompanyVehicleWatcher() {
  yield takeEvery(COMPANY_VEHICLE_SEARCH, searchCompanyVehicle);
}

// List Company Vehicle Status
function* listCompanyVehicleStatus() {
  try {
    const response = yield call(listCompanyVehicleStatusApi);
    yield put(listCompanyVehicleStatusSuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleStatusFailure(error));
  }
}

function* listCompanyVehicleStatusWatcher() {
  yield takeEvery(COMPANY_VEHICLE_STATUS_LIST, listCompanyVehicleStatus);
}

// Create Company Vehicle Status
function* createCompanyVehicleStatus({ payload }) {
  try {
    const response = yield call(createCompanyVehicleStatusApi, payload);
    yield put(createCompanyVehicleStatusSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleStatusFailure(error));
  }
}

function* createCompanyVehicleStatusWatcher() {
  yield takeEvery(COMPANY_VEHICLE_STATUS_CREATE, createCompanyVehicleStatus);
}

// Update Company Vehicle Status
function* updateCompanyVehicleStatus({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleStatusApi, payload);
    yield put(updateCompanyVehicleStatusSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleStatusFailure(error));
  }
}

function* updateCompanyVehicleStatusWatcher() {
  yield takeEvery(COMPANY_VEHICLE_STATUS_UPDATE, updateCompanyVehicleStatus);
}

// Delete Company Vehicle Status
function* deleteCompanyVehicleStatus({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleStatusApi, payload);
    yield put(deleteCompanyVehicleStatusSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleStatusFailure(error));
  }
}

function* deleteCompanyVehicleStatusWatcher() {
  yield takeEvery(COMPANY_VEHICLE_STATUS_DELETE, deleteCompanyVehicleStatus);
}

// List Company Vehicle Type
function* listCompanyVehicleType() {
  try {
    const response = yield call(listCompanyVehicleTypeApi);
    yield put(listCompanyVehicleTypeSuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleTypeFailure(error));
  }
}

function* listCompanyVehicleTypeWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TYPE_LIST, listCompanyVehicleType);
}

// Create Company Vehicle Type
function* createCompanyVehicleType({ payload }) {
  try {
    const response = yield call(createCompanyVehicleTypeApi, payload);
    yield put(createCompanyVehicleTypeSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleTypeFailure(error));
  }
}

function* createCompanyVehicleTypeWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TYPE_CREATE, createCompanyVehicleType);
}

// Update Company Vehicle Type
function* updateCompanyVehicleType({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleTypeApi, payload);
    yield put(updateCompanyVehicleTypeSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleTypeFailure(error));
  }
}

function* updateCompanyVehicleTypeWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TYPE_UPDATE, updateCompanyVehicleType);
}

// Delete Company Vehicle Type
function* deleteCompanyVehicleType({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleTypeApi, payload);
    yield put(deleteCompanyVehicleTypeSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleTypeFailure(error));
  }
}

function* deleteCompanyVehicleTypeWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TYPE_DELETE, deleteCompanyVehicleType);
}

// List Company Vehicle Check Type
function* listCompanyVehicleCheckType() {
  try {
    const response = yield call(listCompanyVehicleCheckTypeApi);
    yield put(listCompanyVehicleCheckTypeSuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleCheckTypeFailure(error));
  }
}

function* listCompanyVehicleCheckTypeWatcher() {
  yield takeEvery(COMPANY_VEHICLE_CHECK_TYPE_LIST, listCompanyVehicleCheckType);
}

// Create Company Vehicle Check Type
function* createCompanyVehicleCheckType({ payload }) {
  try {
    const response = yield call(createCompanyVehicleCheckTypeApi, payload);
    yield put(createCompanyVehicleCheckTypeSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleCheckTypeFailure(error));
  }
}

function* createCompanyVehicleCheckTypeWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_CHECK_TYPE_CREATE,
    createCompanyVehicleCheckType
  );
}

// Update Company Vehicle Check Type
function* updateCompanyVehicleCheckType({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleCheckTypeApi, payload);
    yield put(updateCompanyVehicleCheckTypeSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleCheckTypeFailure(error));
  }
}

function* updateCompanyVehicleCheckTypeWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_CHECK_TYPE_UPDATE,
    updateCompanyVehicleCheckType
  );
}

// Delete Company Vehicle Check Type
function* deleteCompanyVehicleCheckType({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleCheckTypeApi, payload);
    yield put(deleteCompanyVehicleCheckTypeSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleCheckTypeFailure(error));
  }
}

function* deleteCompanyVehicleCheckTypeWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_CHECK_TYPE_DELETE,
    deleteCompanyVehicleCheckType
  );
}

// List Company Vehicle Checks (by vehicle)
function* listCompanyVehicleCheck({ payload }) {
  try {
    const response = yield call(listCompanyVehicleCheckApi, payload);
    yield put(listCompanyVehicleCheckSuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleCheckFailure(error));
  }
}

function* listCompanyVehicleCheckWatcher() {
  yield takeEvery(COMPANY_VEHICLE_CHECK_LIST, listCompanyVehicleCheck);
}

// Create Company Vehicle Check
function* createCompanyVehicleCheck({ payload }) {
  try {
    const response = yield call(createCompanyVehicleCheckApi, payload);
    yield put(createCompanyVehicleCheckSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleCheckFailure(error));
  }
}

function* createCompanyVehicleCheckWatcher() {
  yield takeEvery(COMPANY_VEHICLE_CHECK_CREATE, createCompanyVehicleCheck);
}

// Update Company Vehicle Check
function* updateCompanyVehicleCheck({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleCheckApi, payload);
    yield put(updateCompanyVehicleCheckSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleCheckFailure(error));
  }
}

function* updateCompanyVehicleCheckWatcher() {
  yield takeEvery(COMPANY_VEHICLE_CHECK_UPDATE, updateCompanyVehicleCheck);
}

// Delete Company Vehicle Check
function* deleteCompanyVehicleCheck({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleCheckApi, payload);
    yield put(deleteCompanyVehicleCheckSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleCheckFailure(error));
  }
}

function* deleteCompanyVehicleCheckWatcher() {
  yield takeEvery(COMPANY_VEHICLE_CHECK_DELETE, deleteCompanyVehicleCheck);
}

// List Company Vehicle To Staff (custody history by vehicle)
function* listCompanyVehicleToStaff({ payload }) {
  try {
    const response = yield call(listCompanyVehicleToStaffApi, payload);
    yield put(listCompanyVehicleToStaffSuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleToStaffFailure(error));
  }
}

function* listCompanyVehicleToStaffWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TO_STAFF_LIST, listCompanyVehicleToStaff);
}

// Create Company Vehicle To Staff
function* createCompanyVehicleToStaff({ payload }) {
  try {
    const response = yield call(createCompanyVehicleToStaffApi, payload);
    yield put(createCompanyVehicleToStaffSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleToStaffFailure(error));
  }
}

function* createCompanyVehicleToStaffWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TO_STAFF_CREATE, createCompanyVehicleToStaff);
}

// Update Company Vehicle To Staff
function* updateCompanyVehicleToStaff({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleToStaffApi, payload);
    yield put(updateCompanyVehicleToStaffSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleToStaffFailure(error));
  }
}

function* updateCompanyVehicleToStaffWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TO_STAFF_UPDATE, updateCompanyVehicleToStaff);
}

// Delete Company Vehicle To Staff
function* deleteCompanyVehicleToStaff({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleToStaffApi, payload);
    yield put(deleteCompanyVehicleToStaffSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleToStaffFailure(error));
  }
}

function* deleteCompanyVehicleToStaffWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TO_STAFF_DELETE, deleteCompanyVehicleToStaff);
}

// Search Company Vehicle To Staff (custody log across all vehicles)
function* searchCompanyVehicleToStaff({ payload }) {
  try {
    const response = yield call(searchCompanyVehicleToStaffApi, payload);
    yield put(searchCompanyVehicleToStaffSuccess(response));
  } catch (error) {
    yield put(searchCompanyVehicleToStaffFailure(error));
  }
}

function* searchCompanyVehicleToStaffWatcher() {
  yield takeEvery(COMPANY_VEHICLE_TO_STAFF_SEARCH, searchCompanyVehicleToStaff);
}

// Checkout Company Vehicle (pool car out)
function* checkoutCompanyVehicle({ payload }) {
  try {
    const response = yield call(checkoutCompanyVehicleApi, payload);
    yield put(checkoutCompanyVehicleSuccess(response));
  } catch (error) {
    yield put(checkoutCompanyVehicleFailure(error));
  }
}

function* checkoutCompanyVehicleWatcher() {
  yield takeEvery(COMPANY_VEHICLE_CHECKOUT, checkoutCompanyVehicle);
}

// Checkin Company Vehicle (pool car back)
function* checkinCompanyVehicle({ payload }) {
  try {
    const response = yield call(checkinCompanyVehicleApi, payload);
    yield put(checkinCompanyVehicleSuccess(response));
  } catch (error) {
    yield put(checkinCompanyVehicleFailure(error));
  }
}

function* checkinCompanyVehicleWatcher() {
  yield takeEvery(COMPANY_VEHICLE_CHECKIN, checkinCompanyVehicle);
}

// List Company Vehicle Notes (by vehicle)
function* listCompanyVehicleNote({ payload }) {
  try {
    const response = yield call(listCompanyVehicleNoteApi, payload);
    yield put(listCompanyVehicleNoteSuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleNoteFailure(error));
  }
}

function* listCompanyVehicleNoteWatcher() {
  yield takeEvery(COMPANY_VEHICLE_NOTE_LIST, listCompanyVehicleNote);
}

// Create Company Vehicle Note
function* createCompanyVehicleNote({ payload }) {
  try {
    const response = yield call(createCompanyVehicleNoteApi, payload);
    yield put(createCompanyVehicleNoteSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleNoteFailure(error));
  }
}

function* createCompanyVehicleNoteWatcher() {
  yield takeEvery(COMPANY_VEHICLE_NOTE_CREATE, createCompanyVehicleNote);
}

// Update Company Vehicle Note
function* updateCompanyVehicleNote({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleNoteApi, payload);
    yield put(updateCompanyVehicleNoteSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleNoteFailure(error));
  }
}

function* updateCompanyVehicleNoteWatcher() {
  yield takeEvery(COMPANY_VEHICLE_NOTE_UPDATE, updateCompanyVehicleNote);
}

// Delete Company Vehicle Note
function* deleteCompanyVehicleNote({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleNoteApi, payload);
    yield put(deleteCompanyVehicleNoteSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleNoteFailure(error));
  }
}

function* deleteCompanyVehicleNoteWatcher() {
  yield takeEvery(COMPANY_VEHICLE_NOTE_DELETE, deleteCompanyVehicleNote);
}

// List Company Vehicle Recent Activity
function* listCompanyVehicleRecentActivity({ payload }) {
  try {
    const response = yield call(listCompanyVehicleRecentActivityApi, payload);
    yield put(listCompanyVehicleRecentActivitySuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleRecentActivityFailure(error));
  }
}

function* listCompanyVehicleRecentActivityWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_RECENT_ACTIVITY_LIST,
    listCompanyVehicleRecentActivity
  );
}

// List Company Vehicle GPS Trackers (by vehicle)
function* listCompanyVehicleGpsTracker({ payload }) {
  try {
    const response = yield call(listCompanyVehicleGpsTrackerApi, payload);
    yield put(listCompanyVehicleGpsTrackerSuccess(response));
  } catch (error) {
    yield put(listCompanyVehicleGpsTrackerFailure(error));
  }
}

function* listCompanyVehicleGpsTrackerWatcher() {
  yield takeEvery(COMPANY_VEHICLE_GPS_TRACKER_LIST, listCompanyVehicleGpsTracker);
}

// Create (assign) Company Vehicle GPS Tracker
function* createCompanyVehicleGpsTracker({ payload }) {
  try {
    const response = yield call(createCompanyVehicleGpsTrackerApi, payload);
    yield put(createCompanyVehicleGpsTrackerSuccess(response));
  } catch (error) {
    yield put(createCompanyVehicleGpsTrackerFailure(error));
  }
}

function* createCompanyVehicleGpsTrackerWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_GPS_TRACKER_CREATE,
    createCompanyVehicleGpsTracker
  );
}

// Update Company Vehicle GPS Tracker
function* updateCompanyVehicleGpsTracker({ payload }) {
  try {
    const response = yield call(updateCompanyVehicleGpsTrackerApi, payload);
    yield put(updateCompanyVehicleGpsTrackerSuccess(response));
  } catch (error) {
    yield put(updateCompanyVehicleGpsTrackerFailure(error));
  }
}

function* updateCompanyVehicleGpsTrackerWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_GPS_TRACKER_UPDATE,
    updateCompanyVehicleGpsTracker
  );
}

// Delete (remove) Company Vehicle GPS Tracker
function* deleteCompanyVehicleGpsTracker({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleGpsTrackerApi, payload);
    yield put(deleteCompanyVehicleGpsTrackerSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleGpsTrackerFailure(error));
  }
}

function* deleteCompanyVehicleGpsTrackerWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_GPS_TRACKER_DELETE,
    deleteCompanyVehicleGpsTracker
  );
}

// List GPSLive provider devices (assign dropdown)
function* listGpsLiveDevices() {
  try {
    const response = yield call(listGpsLiveDevicesApi);
    yield put(listGpsLiveDevicesSuccess(response));
  } catch (error) {
    yield put(listGpsLiveDevicesFailure(error));
  }
}

function* listGpsLiveDevicesWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_GPS_TRACKER_PROVIDER_DEVICES,
    listGpsLiveDevices
  );
}

// Refresh a tracker's live position from the provider
function* refreshCompanyVehicleGpsTracker({ payload }) {
  try {
    const response = yield call(refreshCompanyVehicleGpsTrackerApi, payload);
    yield put(refreshCompanyVehicleGpsTrackerSuccess(response));
  } catch (error) {
    yield put(refreshCompanyVehicleGpsTrackerFailure(error));
  }
}

function* refreshCompanyVehicleGpsTrackerWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_GPS_TRACKER_REFRESH,
    refreshCompanyVehicleGpsTracker
  );
}

// Search Company Vehicle Attachments (by vehicle)
function* searchCompanyVehicleAttachment({ payload }) {
  try {
    const response = yield call(searchCompanyVehicleAttachmentApiCall, payload);
    yield put(searchCompanyVehicleAttachmentSuccess(response));
  } catch (error) {
    yield put(searchCompanyVehicleAttachmentFailure(error));
  }
}

function* searchCompanyVehicleAttachmentWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_ATTACHMENT_SEARCH,
    searchCompanyVehicleAttachment
  );
}

// Delete Company Vehicle Attachment
function* deleteCompanyVehicleAttachment({ payload }) {
  try {
    const response = yield call(deleteCompanyVehicleAttachmentApiCall, payload);
    yield put(deleteCompanyVehicleAttachmentSuccess(response));
  } catch (error) {
    yield put(deleteCompanyVehicleAttachmentFailure(error));
  }
}

function* deleteCompanyVehicleAttachmentWatcher() {
  yield takeEvery(
    COMPANY_VEHICLE_ATTACHMENT_DELETE,
    deleteCompanyVehicleAttachment
  );
}

export default function* CompanyVehicle() {
  yield all([
    fork(listCompanyVehiclesWatcher),
    fork(createCompanyVehicleWatcher),
    fork(updateCompanyVehicleWatcher),
    fork(deleteCompanyVehicleWatcher),
    fork(getCompanyVehicleDetailsWatcher),
    fork(searchCompanyVehicleWatcher),
    fork(listCompanyVehicleStatusWatcher),
    fork(createCompanyVehicleStatusWatcher),
    fork(updateCompanyVehicleStatusWatcher),
    fork(deleteCompanyVehicleStatusWatcher),
    fork(listCompanyVehicleTypeWatcher),
    fork(createCompanyVehicleTypeWatcher),
    fork(updateCompanyVehicleTypeWatcher),
    fork(deleteCompanyVehicleTypeWatcher),
    fork(listCompanyVehicleCheckTypeWatcher),
    fork(createCompanyVehicleCheckTypeWatcher),
    fork(updateCompanyVehicleCheckTypeWatcher),
    fork(deleteCompanyVehicleCheckTypeWatcher),
    fork(listCompanyVehicleCheckWatcher),
    fork(createCompanyVehicleCheckWatcher),
    fork(updateCompanyVehicleCheckWatcher),
    fork(deleteCompanyVehicleCheckWatcher),
    fork(listCompanyVehicleToStaffWatcher),
    fork(createCompanyVehicleToStaffWatcher),
    fork(updateCompanyVehicleToStaffWatcher),
    fork(deleteCompanyVehicleToStaffWatcher),
    fork(searchCompanyVehicleToStaffWatcher),
    fork(checkoutCompanyVehicleWatcher),
    fork(checkinCompanyVehicleWatcher),
    fork(listCompanyVehicleNoteWatcher),
    fork(createCompanyVehicleNoteWatcher),
    fork(updateCompanyVehicleNoteWatcher),
    fork(deleteCompanyVehicleNoteWatcher),
    fork(listCompanyVehicleRecentActivityWatcher),
    fork(listCompanyVehicleGpsTrackerWatcher),
    fork(createCompanyVehicleGpsTrackerWatcher),
    fork(updateCompanyVehicleGpsTrackerWatcher),
    fork(deleteCompanyVehicleGpsTrackerWatcher),
    fork(listGpsLiveDevicesWatcher),
    fork(refreshCompanyVehicleGpsTrackerWatcher),
    fork(searchCompanyVehicleAttachmentWatcher),
    fork(deleteCompanyVehicleAttachmentWatcher),
  ]);
}
